import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import PropTypes from 'prop-types';

const ProtectiveRoutes = ({children}) => {
  let accessToken = useSelector((state) => state.accessToken);
  if(!accessToken) 
    accessToken = localStorage.getItem('accessToken');
  console.log('accessToken',accessToken);
  if(!accessToken ) {
    return <Navigate to="/signin"/>
  }
  return children;
}

ProtectiveRoutes.propTypes = {
  children: PropTypes.any
};

export default ProtectiveRoutes